import AgentsChatPage from './views/AgentsChat';

export const agentsChatRoutes = [
  {
    path: 'agents-chat',
    name: '智能体',
    icon: 'robot',
    element: <AgentsChatPage />,
  },
];
